import React, {FC, lazy, Suspense} from 'react';
import {Metric, Result} from 'templates/reports/Section/RegionalComp/parse';
import {title} from 'utils/title';

import * as styles from './styles.module.scss';

const LazyChart = lazy(() => import('templates/reports/Section/RegionalComp/Snapshot/Charts/Bars/Chart'));

const DynamicChart: FC<BarsProps> = (props) => (
	<Suspense fallback={null}>
		<LazyChart {...props} />
	</Suspense>
);

type BarsProps = {
	metric: Metric
	result: Result
}

export const Bars: FC<BarsProps> = (props) => {
	const {metric, result} = props;
	return (
		<div className={styles.bars}>
			<h3>{title(metric)} % by region</h3>
			<h4>
				Avg body {metric}: {result.total[metric].pct_region.toFixed(1)}%
			</h4>
			<DynamicChart {...props} />
		</div>
	);
};
